// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__a9wOQ","Menu":"SiderContentC_Menu__Qnw+6"};